import React, { memo, useState, useEffect } from 'react'
import { Button, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import DsrBanner from '../common/dsr-banner'
import { ZETTLE_EU_URL } from '../../../constants/constants'
import { fptiCustomImpression, fptiCustomClick } from '../../../utils'

const DSRLandingPage = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(dsrFpti.IMPRESSION)
    }
  }, [impressionDone, dsrFpti])
  const handleGetStarted = (event) => {
    event.preventDefault()
    fptiCustomClick(dsrFpti.GETSTARTED_BTN)
    props.changeState('DSRFORM')
  }
  const handleLinkClick = () => {
    fptiCustomClick(dsrFpti.ZETTLE_EU_LINK)
  }
  const bannerContent = {
    header: <Message id="dsrZettle.landing.header.title" />,
    description: <Message id="dsrZettle.landing.header.description" />,
  }
  return (
    <>
      <DsrBanner {...bannerContent} />
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <p className="text-center">
              <Message id="dsrZettle.landing.body.description" />
            </p>
            <div className="button-container">
              <Button theme="v2" id="getstartedbtn" onClick={handleGetStarted}>
                <Message id="dsrZettle.landing.body.button.label" />
              </Button>
            </div>
            <div>
              <p className="text-center">
                <Message
                  id="dsrZettle.landing.body.euportal.link"
                  link={(innerMessage) => (
                    <Link
                      href={ZETTLE_EU_URL}
                      onClick={handleLinkClick}
                      theme="v2"
                    >
                      {innerMessage}
                    </Link>
                  )}
                />
              </p>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
DSRLandingPage.displayName = 'DSRLandingPage'

export default DSRLandingPage
